import { render, staticRenderFns } from "./order_prescription.vue?vue&type=template&id=21b0ab9e"
import script from "./order_prescription.vue?vue&type=script&lang=js"
export * from "./order_prescription.vue?vue&type=script&lang=js"
import style0 from "./order_prescription.vue?vue&type=style&index=0&id=21b0ab9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports